<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rLDcLu/tc-custom/9780374715908.jpg?1730609802402" alt="This image is the cover for the book Jacob's Ladder"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jacob's Ladder
      </h1>
      <p class="bookDescription body article font2">
        <p><b>From a Man Booker International Prize nominee, “a century of tangled Russian family history in [a] lucid saga . . .a challenging yet rewarding epic.” ―<i>Publishers Weekly</i></b><br/>  <br/> “Ulitskaya continues the tradition of prerevolutionary Russian literature and demonstrates why she’s one of the most popular novelists in today’s Russia.” –<i>The New York Times</i>.<br/>  <br/> Jumping between the diaries and letters of Jacob Ossetsky in Kiev in the early 1900s and the experiences of his granddaughter Nora in the theatrical world of Moscow in the 1970s and beyond, <i>Jacob’s Ladder</i> guides the reader through some of the most turbulent times in the history of Russia and Ukraine, and draws suggestive parallels between historical events of the early twentieth century and those of more recent memory.<br/>  <br/> Spanning the seeming promise of the prerevolutionary years, to the dark Stalinist era, to the corruption and confusion of the present day, <i>Jacob’s Ladder</i> is a pageant of romance, betrayal, and memory. With a scale worthy of Tolstoy, it asks how much control any of us have over our lives—and how much is in fact determined by history, by chance, or indeed by the genes passed down by the generations that have preceded us into the world.<br/>  <br/> “An expansive novel about the complications of human lives and repeating generational patterns, set against a backdrop that skips across a century of tumultuous Russian and Soviet history.” ―<i>Booklist</i><br/>  <br/> “A sweeping, ambitious story reminiscent at times of Pasternak in its grasp of both history and tragedy.” —<i>Kirkus Reviews, </i>starred review </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ludmila Ulitskaya, Polly Gannon
      </h2>
      
      <p class="authorDescription body article"><P><B>Ludmila Ulitskaya </B>is one of Russia’s most popular and renowned literary figures. A former scientist and the director of Moscow’s Hebrew Repertory Theater, she is the author of more than a dozen works of fiction, including <I>The Big Green Tent</I>; several tales for children; and multiple plays that have been staged by a number of theaters in Russia and Germany. She has won Russia’s Man Booker Prize and twice won its Big Book Prize, as well as being nominated for the Man Booker International Prize.<br><br><B>Polly Gannon</B> is the director of cultural studies at the New York-St. Petersburg Institute of Linguistics, Cognition and Culture. She holds a Ph.D. in Russian literature from Cornell University. She lives, teaches, and translates in St. Petersburg, Russia.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?970fbefa